/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function elementInViewport(event) {
var myElement = document.querySelector('.normalvideo');
if(document.querySelector('.normalvideo')){
if(myElement.offsetTop  + document.body.getBoundingClientRect().top <= 0){
   if(document.getElementById("videoPlayer").paused == true && !document.body.classList.contains('videoplaying')){ 
    document.getElementById("playbtn").click();
  }
  
}
}
   
}
if(document.getElementById("playbtn")){
document.getElementById("playbtn").addEventListener('click', function(event) {
     document.body.classList.add("videoplaying");
     document.getElementById("videoPlayer").play();
    
    
});
}
window.addEventListener("scroll", event => {
  elementInViewport(event);
});
if(document.getElementById("beer-range")){
var rangeslider = document.getElementById("beer-range");
var output = document.querySelector(".beer-handle");
  var inpout = document.querySelector(".beer-reveal");
output.style.left = rangeslider.value+"%";
inpout.style.width = rangeslider.value+"%";
rangeslider.oninput = function() {
 
output.style.left = this.value+"%";
  inpout.style.width = rangeslider.value+"%";
}
}
if(document.getElementById("label-filter")){
document.getElementById("label-filter").addEventListener('click', function(event) {
     var x = document.getElementById("filter-dropwdown");
     x.classList.toggle("open");
    
});
}
if(document.getElementById("CollectionToolbar__Group")){
document.getElementById("CollectionToolbar__Group").addEventListener('click', function(event) {
     var x = document.getElementById("filter-dropwdown");
     x.classList.remove("open");
    
});
}
document.getElementById("footer-0").addEventListener('click', function(event) {
     var x = document.getElementById("block-0");
     x.classList.toggle("open");
    
});
document.getElementById("footer-1").addEventListener('click', function(event) {
      var x = document.getElementById("block-1");
     x.classList.toggle("open");
});
document.getElementById("footer-2").addEventListener('click', function(event) {
     var x = document.getElementById("block-2");
     x.classList.toggle("open");
});
if(document.getElementById("faqdropdown")){
document.getElementById("faqdropdown").addEventListener('change', function(event) {
    var cls = document.getElementById("faqdropdown").value;  
    [].forEach.call(document.querySelectorAll('.Faq__Item'), function (el) {
        el.style.display = 'none';
      });
     [].forEach.call(document.querySelectorAll('.'+cls), function (el) {
        el.style.display = 'block';
      });
  });
}
function toggleNotification(id){
  var element = document.getElementById("prdt_login_me"+id);
  element.classList.toggle("show");
}
function addNew(id){
   var element = document.getElementById("qty-"+id);
    element.value = parseInt( element.value)+1;
}
function minusExisting(id){
  var element = document.getElementById("qty-"+id);
  if(parseInt( element.value) > 0){
    element.value = parseInt( element.value) - 1;
  }
}
function notifyMe(){
  document.getElementById("BIS_trigger").click();
}
function personaizeProduct(id,title) {
    title = title.split("|");
  document.getElementById("personaizeProduct").click();
   var interval = setInterval(function(){
     if( document.querySelector(".crop-modal")){
         clearInterval(interval);
             document.querySelector('input[name="id"]').value =  id; 
              document.getElementsByClassName("pplrlabel")[0].innerHTML =  title[1] +'<span class="pplr_option_price_span"></span>';
             //$(".pplr-title .pplrlabel").html(title[1] +'<span class="pplr_option_price_span"></span>');
            }
      },200);
 
}


var script = document.createElement('script'); 
document.head.appendChild(script);    
script.type = 'text/javascript';
script.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js";
script.onload = function(){
    console.log('jQuery ${$.fn.jquery} has been loaded successfully!');
    jQuery('.tablinks:eq(0)').trigger('click');
}  

document.addEventListener("DOMContentLoaded", function () {
  let variantElements = document.querySelectorAll('.variant-item'); // Adjusted to your class name

  variantElements.forEach(function (element) {
    let text = element.innerText.toLowerCase(); // Normalize case
    if (text.includes("monogram")) {
      element.style.display = "none"; // Hide the element
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let variantElements = document.querySelectorAll('.newvar_color_ul .displaycolorvariant_1'); // Select all variant options

  variantElements.forEach(function (element) {
    let linkElement = element.querySelector('a'); // Find link inside variant

    if (linkElement && linkElement.href) {
      let variantURL = linkElement.href.toLowerCase();
      console.log("Checking variant URL:", variantURL); // Debugging output

      if (variantURL.includes("pplr")) {
        element.style.display = "none"; // Hide only PPLR variants
        console.log("✅ Hiding variant with PPLR:", variantURL);
      } else {
        element.style.display = ""; // Reset display to ensure other elements remain visible
        console.log("🚀 Keeping variant visible:", variantURL);
      }
    } else {
      console.log("⚠️ No <a> tag found inside variant element:", element);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
    let priceElement = document.querySelector(".ProductItem__Price"); // Adjust selector if needed

    if (priceElement) {
        let priceText = priceElement.innerText.trim();
        let priceRange = priceText.match(/\$[0-9]+/g); // Extract all prices

        if (priceRange) {
            priceRange = priceRange.map(price => parseInt(price.replace("$", ""))); // Convert to numbers
            let validPrices = priceRange.filter(price => price > 0); // Exclude $0

            if (validPrices.length > 0) {
                let minPrice = Math.min(...validPrices);
                let maxPrice = Math.max(...validPrices);

                // Update the price range display
                priceElement.innerText = minPrice === maxPrice ? `$${minPrice}` : `$${minPrice} - $${maxPrice}`;
            }
        }
    }
});